/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown>, sets: NonNullable<unknown>, floor: NonNullable<unknown> }} Prescription_Notice_Volume_Below_FloorInputs */

const en_us2_prescription_notice_volume_below_floor = /** @type {(inputs: Prescription_Notice_Volume_Below_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.sets} sets a week, under the minimum of ${i?.floor}.`)
};

const pt_br2_prescription_notice_volume_below_floor = /** @type {(inputs: Prescription_Notice_Volume_Below_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.sets} séries por semana, abaixo do mínimo de ${i?.floor}.`)
};

const es_419_prescription_notice_volume_below_floor = /** @type {(inputs: Prescription_Notice_Volume_Below_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.sets} series por semana, por debajo del mínimo de ${i?.floor}.`)
};

const pt_pt2_prescription_notice_volume_below_floor = /** @type {(inputs: Prescription_Notice_Volume_Below_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.sets} séries por semana, abaixo do mínimo de ${i?.floor}.`)
};

const fr_fr2_prescription_notice_volume_below_floor = /** @type {(inputs: Prescription_Notice_Volume_Below_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} : ${i?.sets} séries par semaine, sous le minimum de ${i?.floor}.`)
};

const de_de2_prescription_notice_volume_below_floor = /** @type {(inputs: Prescription_Notice_Volume_Below_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.sets} Sätze pro Woche, unter dem Minimum von ${i?.floor}.`)
};

const it_it2_prescription_notice_volume_below_floor = /** @type {(inputs: Prescription_Notice_Volume_Below_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.sets} serie a settimana, sotto il minimo di ${i?.floor}.`)
};

/**
* | output |
* | --- |
* | "{muscle}: {sets} sets a week, under the minimum of {floor}." |
*
* @param {Prescription_Notice_Volume_Below_FloorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_notice_volume_below_floor = /** @type {((inputs: Prescription_Notice_Volume_Below_FloorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Notice_Volume_Below_FloorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_notice_volume_below_floor(inputs)
	if (locale === "es-419") return es_419_prescription_notice_volume_below_floor(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_notice_volume_below_floor(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_notice_volume_below_floor(inputs)
	if (locale === "de-DE") return de_de2_prescription_notice_volume_below_floor(inputs)
	if (locale === "it-IT") return it_it2_prescription_notice_volume_below_floor(inputs)
	return en_us2_prescription_notice_volume_below_floor(inputs)
});
export { prescription_notice_volume_below_floor as "prescription.notice.volume_below_floor" }